if (!customElements.get('smooche-below-atc')) {
  customElements.define('smooche-below-atc', class extends HTMLElement {
    connectedCallback() {
      var root = this;
      this.controller = new AbortController();
      var signal = this.controller.signal;

      var items = root.querySelectorAll('.cs-below-atc__faq-item');
      items.forEach(function (item) {
        var btn = item.querySelector('.cs-below-atc__faq-btn');
        var panel = item.querySelector('.cs-below-atc__faq-collapse');
        if (!btn || !panel) return;

        btn.addEventListener('click', function () {
          var open = item.classList.contains('is-open');
          if (open) {
            panel.style.height = panel.scrollHeight + 'px';
            panel.offsetHeight;
            panel.style.height = '0px';
            item.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
          } else {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            panel.style.height = panel.scrollHeight + 'px';
            var onEnd = function (e) {
              if (e.propertyName !== 'height') return;
              if (item.classList.contains('is-open')) panel.style.height = 'auto';
              panel.removeEventListener('transitionend', onEnd);
            };
            panel.addEventListener('transitionend', onEnd);
          }
        }, { signal: signal });
      });
      root.addEventListener('shopify:block:select', function(event) {
        var item = event.target.closest('.cs-below-atc__faq-item');
        if (item && !item.classList.contains('is-open')) item.querySelector('button').click();
      }, { signal: signal });
    }
    disconnectedCallback() {
      this.controller.abort();
    }
  });
}
